var exports = {
  "iU": "Message.module__message___MFAxam",
  "Ph": "Message.module__messagePreviewSpacing___MFAxam",
  "IL": "Message.module__messagePreview___MFAxam",
  "uK": "Message.module__focusRingAnchor___MFAxam",
  "J8": "Message.module__messageCompact___MFAxam",
  "Xo": "Message.module__messageHovered___MFAxam",
  "L8": "Message.module__messageMentioned___MFAxam",
  "m6": "Message.module__messageReplying___MFAxam",
  "O6": "Message.module__messageHighlight___MFAxam",
  "lY": "Message.module__contextMenuActive___MFAxam",
  "Bc": "Message.module__mobileLayout___MFAxam",
  "p2": "Message.module__messageLongPress___MFAxam",
  "Uw": "Message.module__messageGrouped___MFAxam",
  "kT": "Message.module__messageEditing___MFAxam",
  "E4": "Message.module__messageSent___MFAxam",
  "mr": "Message.module__messageSending___MFAxam",
  "b$": "Message.module__messageFailed___MFAxam",
  "RZ": "Message.module__failedFooter___MFAxam",
  "Iu": "Message.module__failedFooterMessage___MFAxam",
  "bg": "Message.module__failedFooterLabel___MFAxam",
  "OZ": "Message.module__failedFooterIcon___MFAxam",
  "dv": "Message.module__failedRetryIcon___MFAxam",
  "QW": "Message.module__failedRetryButton___MFAxam",
  "q5": "Message.module__messageGutterLeft___MFAxam",
  "ZN": "Message.module__messageGutterRight___MFAxam",
  "$7": "Message.module__messageAvatar___MFAxam",
  "CW": "Message.module__messageNoText___MFAxam",
  "U7": "Message.module__messageContent___MFAxam",
  "rO": "Message.module__messageAuthorInfo___MFAxam",
  "xW": "Message.module__jumpHeading___MFAxam",
  "RO": "Message.module__jumpHeadingButton___MFAxam",
  "dw": "Message.module__messageAuthorRow___MFAxam",
  "AY": "Message.module__messageAuthorPart___MFAxam",
  "x": "Message.module__userTagOffset___MFAxam",
  "oL": "Message.module__messageTimestamp___MFAxam",
  "BK": "Message.module__authorDashSeparator___MFAxam",
  "um": "Message.module__messageUsername___MFAxam",
  "Lo": "Message.module__messageText___MFAxam",
  "L5": "Message.module__messageTimestampCompact___MFAxam",
  "tQ": "Message.module__compactAuthorPrefix___MFAxam",
  "U6": "Message.module__copyOnly___MFAxam",
  "Mz": "Message.module__compactInlineContent___MFAxam",
  "aM": "Message.module__systemMessageContent___MFAxam",
  "vd": "Message.module__messageRoleIcon___MFAxam",
  "vp": "Message.module__contextMenuUnderline___MFAxam",
  "aE": "Message.module__messageTimeoutIndicator___MFAxam",
  "t4": "Message.module__textSeparator___MFAxam",
  "KL": "Message.module__messageTimestampHover___MFAxam",
  "jh": "Message.module__messageTimestampCompactHover___MFAxam",
  "iZ": "Message.module__messageAvatarCompact___MFAxam",
  "kq": "Message.module__compactContentWrapper___MFAxam",
  "xv": "Message.module__hoverAction___MFAxam",
  "kL": "Message.module__container___MFAxam",
  "tI": "Message.module__repliedMessage___MFAxam",
  "_T": "Message.module__repliedMessageCompact___MFAxam",
  "$y": "Message.module__repliedTextPreview___MFAxam",
  "NL": "Message.module__repliedAvatar___MFAxam",
  "a3": "Message.module__repliedIconContainer___MFAxam",
  "Pq": "Message.module__repliedIcon___MFAxam",
  "EK": "Message.module__repliedUsername___MFAxam",
  "IQ": "Message.module__repliedItalic___MFAxam",
  "t": "Message.module__unstyled___MFAxam",
  "Io": "Message.module__repliedTextContent___MFAxam",
  "c": "Message.module__systemMessageFollowsSystem___MFAxam",
  "Hj": "Message.module__systemMessageIconWrapper___MFAxam",
  "Po": "Message.module__systemMessageIconCompact___MFAxam",
  "jJ": "Message.module__systemMessageTimestamp___MFAxam",
  "rc": "Message.module__systemMessageContentWrapper___MFAxam",
  "V_": "Message.module__systemMessageCompactContent___MFAxam",
  "Gq": "Message.module__systemMessageIconSvg___MFAxam",
  "hr": "Message.module__systemMessageLink___MFAxam",
  "ll": "Message.module__userTagCompact___MFAxam",
  "Qh": "Message.module__messageAuthorName___MFAxam",
  "O4": "Message.module__editedTimestamp___MFAxam",
  "k8": "Message.module__editedLabel___MFAxam",
  "zX": "Message.module__typingContainer___MFAxam",
  "Y9": "Message.module__typingCluster___MFAxam",
  "RL": "Message.module__typingIndicator___MFAxam",
  "Kl": "Message.module__typingAvatarContainer___MFAxam",
  "tY": "Message.module__typingText___MFAxam",
  "AZ": "Message.module__typingClusterComposerStatus___MFAxam",
  "am": "Message.module__compactContentNoPrefix___MFAxam",
  "Ys": "Message.module__compactBody___MFAxam",
  "Ac": "Message.module__unknownMessageCompactContent___MFAxam",
  "qU": "Message.module__unknownMessageWarning___MFAxam",
  "NG": "Message.module__keyboardFocused___MFAxam",
  "an": "Message.module__messageClientSystem___MFAxam",
  "og": "Message.module__systemMessageContainer___MFAxam",
  "Is": "Message.module__systemMessageIcon___MFAxam",
  "ry": "Message.module__mediaFocusRing___MFAxam",
  "xS": "Message.module__systemMessageDismissButton___MFAxam",
  "Eu": "Message.module__silentMessageIcon___MFAxam",
};

module.exports = exports;
